import React, { memo } from 'react';
import { UtilityNav } from 'web-ui-components/lib/navigation/site-navs';
import { HelpButton } from '../GlobalHelp/';
import { DIP_UNLIKELY_RESULT } from 'constants/paths';

const UtilityNavigation = memo(function UtilityNavigation({ location }) {
  return <UtilityNav rightContent={location.pathname !== DIP_UNLIKELY_RESULT && <HelpButton />} />;
});

export { UtilityNavigation };
